import React, { useState, useEffect } from "react";
import TabList from "../../Components/TabList";
import { Grid, Box, Container, Typography, TextField, Alert } from "@mui/material";
import axiosInstance from '../../interceptor/interceptor';
import { useLocation, Link } from 'react-router-dom';
//Components
import IndexHeader from "../../Components/IndexHeader";
import Footer from "../../Components/Footer";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const ResetPassword = () => {
    const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  // access query parameters
  const token = queryParams.get("token");
    const [ifPageValid, setIfPageValid] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState("");
    const [successMsg, setSuccessMsg] = React.useState("");
    const [inputField, setInputField] = React.useState({
        token: "",
        email: "",
        password: "",
    });

    const inputsHandler = (e) => {
        setInputField({ ...inputField, [e.target.name]: e.target.value });
    }

    useEffect(()=>{
        validateToken();
    }, []);

    const validateToken = async () =>{
        try{
            const res = await axiosInstance.post(
                `api?method=reset_password`,
                {token:token ,task: "validate",password:""}
            );
            if(res.data.status == 200){
                setIfPageValid(true);
            }
            else {
                setIfPageValid(false);
                setErrMsg(res.data.message);
            }
        } catch (e) {
            setIfPageValid(false);
            setErrMsg(e.response?.data?.message || 'Something went wrong.');
        }
    }
    const handleFormSubmit = async () => {
        try {
          // Validate User Input
          if(inputField.password == ""){
            setErrMsg("Password is missing."); return;
          }
          const res = await axiosInstance.post(
            `api?method=reset_password`,
            {token:token, password: inputField.password, task:"reset"}
          );
          if(res.data.status == 200){
                setSuccessMsg(res.data.message);
                setInputField({password: "" });
                setIfPageValid(false);
            }
            else {
                setErrMsg(res.data.message);
            }
        } catch (e) {
            setErrMsg(e.response?.data?.message || 'Something went wrong.');
        //   toast.info(`Error: ${e.response?.data?.message || 'Something went wrong.'}`, { type: "error" });
        }
      };
    
  return (
    <>
      <IndexHeader />
      <Typography style={{display: 'flex', justifyContent: 'center', marginTop:'70px'}} variant="h4" component="h2">
        <strong>Reset Password</strong>
      </Typography>

      <Grid container>
        <Container maxWidth="lg" className="header-container-1">
            <Typography variant="h2" component="h3" className="form-heading" style={{fontWeight:'500', padding:'10px 0px', textAlign:'center',fontSize:'24px', marginTop:"50px", marginBottom:"50px"}}>Enter New Password</Typography>
            
            <Grid container style={{ justifyContent:'center'}}>
                {/* <Grid item xs={4}></Grid> */}
                <Grid item xs={8} md={4}  >
                    
                    {successMsg && <Alert severity="success">{successMsg}</Alert>}
                    {errMsg && <Alert severity="error">{errMsg}</Alert>}
                     { (successMsg || errMsg) && <div style={{textAlign:"center", marginTop:"20px"}}>
                            <Link type="button" className="btn-small bg-dark shadow text-white td-none fw-b"to="/login">Click to Log in</Link>
                        </div>
                    }      
                    {ifPageValid && <form style={{margin:'0px 10px'}}>                    
                        <TextField
                            value={inputField.password}
                            onChange={inputsHandler}
                            style={{ marginBottom: "10px", width: "100%" }}
                            type="password"
                            label="Password"
                            variant="outlined"
                            name="password"
                            maxLength={50}
                        />
                        <button type="button" className="email-login-register-btn bg-dark text-white shadow" onClick={handleFormSubmit}>Submit</button>
                    </form>}
                            
                </Grid>
            </Grid>

        </Container>
      </Grid>
      <Grid container style={{position: "fixed", bottom: "0"}}>
      <Footer />
      </Grid>
      
    </>
  );
};

export default ResetPassword;
